const COLORS = {
  black: 'var(--color-black)',
  blue: 'var(--color-brand-blue)',
  gray: 'var(--color-brand-gray)',
  green: 'var(--color-green400)',
  lightGray: 'var(--color-brand-light-gray)',
  orange: 'var(--color-brand-orange)',
  purple: 'var(--color-brand-purple)',
  red: 'var(--color-brand-red)',
  white: 'var(--color-white)',
  xlightGray: 'var(--color-brand-xlight-gray)',
  yellow: 'var(--color-brand-yellow)',
};

export default COLORS;

const GRAYS = {
  xdark: 'var(--color-gray-xdark)',
  dark: 'var(--color-gray-dark)',
  medium: 'var(--color-gray-medium)',
  light: 'var(--color-gray-light)',
  xlight: 'var(--color-gray-xlight)',
  xxlight: 'var(--color-gray-xxlight)',
  xxxlight: 'var(--color-gray-xxxlight)',
  xxxxlight: 'var(--color-gray-xxxxlight)',
};

export { GRAYS };
